// NPM
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

// ANT COMPONENTS
import { StackScreen } from '@life-line-lab/components-react';

// INTERNAL COMPONENTS
import CustomerCreateSuccessComponent from 'Components/customer-management/customer-create-success';

// HELPERS
import { decode } from 'Helpers/enc';

// SERVICES
import { fetchCustomer } from 'Services/customer.service';

interface CustomerCreateSuccessPageProps {

}

const CustomerCreateSuccessPage: React.FC<CustomerCreateSuccessPageProps> = ({

}) => {

    const history = useHistory();
    const { t } = useTranslation();

    const { id } = useParams<{ id: string }>();
    const orgID = decode(id);
    const [data, setData] = useState<any>({});

    useEffect(() => {
        document.body.classList.add('stack-screen--open');
        return () => document.body.classList.remove('stack-screen--open');
    }, []);

    useEffect(() => {
        handleFetchCustomerDetails();
    }, [orgID]);

    const handleCloseStackScreen = () => {
      history.push('/customer-management/profile');
    }

    const handleFetchCustomerDetails = async () => {
        if (orgID) {
            const responseData = await fetchCustomer(orgID);

            if (responseData && !responseData.error) {
                setData(responseData);
            } else {
                handleCloseStackScreen();
            }
        }
    }

    return (
        <StackScreen
            title={
                <div>
                    <img
                        alt={t('alt.logo')}
                        src="/assets/images/banner_logo.png"
                        height={30}
                    />
                    <span className="ml-15">
                        {t("title.customerRegistration").toUpperCase()}
                    </span>
                </div>
            }
            isOpen={true}
            renderHeader={<div></div>}
            onClose={handleCloseStackScreen}
        >
            <CustomerCreateSuccessComponent data={data} />
        </StackScreen>
    );
}

export default CustomerCreateSuccessPage;